import { Row } from '@/app/components/Flex/Flex'
import { Layout } from '@/app/components/Layout/Layout'
import { MenuFooter } from '@/app/components/MenuFooter/MenuFooter'
import { Motion } from '@/app/components/Motion/Motion'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import { useNavigate } from '@/app/hooks/useNavigate'
import { useSession } from '@/app/state/session'
import { api } from '@/app/utils/api'
import { parseError } from '@/app/utils/error'
import { metrikaGoal } from '@/app/utils/metrika'
import type { FunctionalComponent } from 'preact'
import { useEffect, useRef, useState } from 'preact/hooks'
import { useSearchParams } from 'wouter-preact'

export const SubscriptionSuccessPage: FunctionalComponent<{
  path?: string
}> = () => {
  const [params] = useSearchParams()

  const route = useNavigate()
  const fetchSession = useSession(s => s.fetch)
  const [status, setStatus] = useState<'pending' | 'succeeded' | 'canceled'>('pending')
  const [errors, setErrors] = useState<string[]>([])
  const [pollingStopped, setPollingStopped] = useState(false)
  const sessionFetchedRef = useRef(false)

  useEffect(() => {
    let timer: number
    let attempts = 0

    const checkStatus = async () => {
      try {
        const res = await api.get(`/payment/status?id=${params.get('id')}`)
        const { status, paymentId } = res.data

        setStatus(status)

        if (status === 'succeeded' && paymentId) {
          if (!sessionFetchedRef.current) {
            sessionFetchedRef.current = true
            await fetchSession()
          }

          const trackedKey = `payment_tracked_${paymentId}`
          if (!localStorage.getItem(trackedKey)) {
            metrikaGoal('payment_success')
            localStorage.setItem(trackedKey, '1')
          }
        }

        if (status === 'pending' && attempts < 20) {
          attempts++
          timer = window.setTimeout(checkStatus, 3000)
        }
        else if (status === 'pending') {
          setPollingStopped(true)
        }
      }
      catch (e) {
        console.error(e)
        setErrors(parseError(e))
      }
    }

    checkStatus()

    return () => clearTimeout(timer)
  }, [params])

  return (
    <Layout>
      <Layout.Content
        onBack={() => {
          route('/tools', { replace: true })
        }}
      >
        <Row gap={15} flexGrow={1}>
          <Motion>
            <Layout.Header>
              {status === 'succeeded'
                ? <>Доступ активирован</>
                : status === 'canceled'
                ? <>Оплата не прошла</>
                : <>Проверяем оплату</>}
            </Layout.Header>

            <Row gap={15}>
              {errors.length > 0
                ? (
                  errors.map(error => (
                    <Motion key={error}>
                      <UI.Panel>
                        <Text fontSize={16}>
                          {error}
                        </Text>
                      </UI.Panel>
                    </Motion>
                  ))
                )
                : status === 'succeeded'
                ? (
                  <Motion>
                    <UI.Panel>
                      <Row gap={5}>
                        <Text fontSize={18} fontWeight={600}>
                          Оплата прошла ✨
                        </Text>
                        <Text fontSize={16}>
                          Сообщения уже у тебя. Пиши в любое время&nbsp;💜
                        </Text>
                      </Row>
                    </UI.Panel>
                  </Motion>
                )
                : status === 'canceled'
                ? (
                  <Motion>
                    <UI.Panel>
                      <Text fontSize={16}>
                        Похоже, платёж не завершился. Попробуй ещё раз&nbsp;💜
                      </Text>
                    </UI.Panel>
                  </Motion>
                )
                : pollingStopped
                ? (
                  <Motion>
                    <UI.Panel>
                      <Row gap={5}>
                        <Text fontSize={18} fontWeight={600}>
                          Оплата не завершена
                        </Text>
                        <Text fontSize={16}>
                          Если платёж уже был сделан, подожди немного и проверь доступ. Если нет, попробуй ещё раз.
                        </Text>
                      </Row>
                    </UI.Panel>
                  </Motion>
                )
                : (
                  <Motion>
                    <UI.Panel>
                      <Text fontSize={16}>
                        Обычно это занимает несколько секунд. Полный доступ откроется автоматически.
                      </Text>
                    </UI.Panel>
                  </Motion>
                )}

              {
                /* {errors.length > 0 || status === 'canceled'
                ? (
                  <Motion>
                    <UI.Button
                      block
                      size='l'
                      type='primary'
                      onClick={() => {
                        metrikaGoal('subscription_back')
                        route('/tools', { replace: true })
                      }}
                    >
                      Вернуться назад
                    </UI.Button>
                  </Motion>
                )
                : (status === 'succeeded' || pollingStopped)
                ? (
                  <Motion>
                    <UI.Button
                      block
                      size='l'
                      type='primary'
                      onClick={() => {
                        if (!pollingStopped) {
                          metrikaGoal('subscription_start')
                        }
                        route('/tools', { replace: true })
                      }}
                    >
                      Вернуться к чату
                    </UI.Button>
                  </Motion>
                )
                : (
                  <Motion>
                    <UI.Button
                      block
                      size='l'
                      type='primary'
                      disabled
                    >
                      <Col gap={8}>
                        Проверяем оплату
                        <Spinner />
                      </Col>
                    </UI.Button>
                  </Motion>
                )} */
              }
            </Row>
          </Motion>
        </Row>

        <MenuFooter />
      </Layout.Content>
    </Layout>
  )
}
